/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPackage
 */
export interface SubscriptionPackage {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPackage
     */
    name?: string;
    /**
     * Stable translation identifier for standard packages.
     * @type {string}
     * @memberof SubscriptionPackage
     */
    code?: string | null;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackage
     */
    maxUsers?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackage
     */
    maxIntegrations?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionPackage
     */
    maxDomains?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    dataUpdatesPerDay?: number;
    /**
     * Whether the package belongs to the public catalog available to every project.
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    _public?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    isDefault?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    monthlyCzk?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    yearlyCzk?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    monthlyEur?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackage
     */
    yearlyEur?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    allowDiscountCodeEvaluation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    allowInfluencerEvaluation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    allowAffiliateEvaluation?: boolean;
    /**
     * Archived packages stay available for existing subscriptions but cannot be offered publicly.
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    isArchived?: boolean;
    /**
     * Maximum rolling history in months; zero or negative means unlimited.
     * @type {number}
     * @memberof SubscriptionPackage
     */
    retentionMonths?: number;
    /**
     * Whether the package belongs to the legacy pricing catalog.
     * @type {boolean}
     * @memberof SubscriptionPackage
     */
    isLegacy?: boolean;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionPackage
     */
    features?: object;
    /**
     * 
     * @type {any}
     * @memberof SubscriptionPackage
     */
    id?: any | null;
}

/**
 * Check if a given object implements the SubscriptionPackage interface.
 */
export function instanceOfSubscriptionPackage(value: object): value is SubscriptionPackage {
    return true;
}

export function SubscriptionPackageFromJSON(json: any): SubscriptionPackage {
    return SubscriptionPackageFromJSONTyped(json, false);
}

export function SubscriptionPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] === undefined ? undefined : json['code'] === null ? null : json['code'],
        'maxUsers': json['maxUsers'] == null ? undefined : json['maxUsers'],
        'maxIntegrations': json['maxIntegrations'] == null ? undefined : json['maxIntegrations'],
        'maxDomains': json['maxDomains'] == null ? undefined : json['maxDomains'],
        'dataUpdatesPerDay': json['dataUpdatesPerDay'] == null ? undefined : json['dataUpdatesPerDay'],
        '_public': json['public'] == null ? undefined : json['public'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'monthlyCzk': json['monthlyCzk'] == null ? undefined : json['monthlyCzk'],
        'yearlyCzk': json['yearlyCzk'] == null ? undefined : json['yearlyCzk'],
        'monthlyEur': json['monthlyEur'] == null ? undefined : json['monthlyEur'],
        'yearlyEur': json['yearlyEur'] == null ? undefined : json['yearlyEur'],
        'allowDiscountCodeEvaluation': json['allowDiscountCodeEvaluation'] == null ? undefined : json['allowDiscountCodeEvaluation'],
        'allowInfluencerEvaluation': json['allowInfluencerEvaluation'] == null ? undefined : json['allowInfluencerEvaluation'],
        'allowAffiliateEvaluation': json['allowAffiliateEvaluation'] == null ? undefined : json['allowAffiliateEvaluation'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'retentionMonths': json['retentionMonths'] == null ? undefined : json['retentionMonths'],
        'isLegacy': json['isLegacy'] == null ? undefined : json['isLegacy'],
        'features': json['features'] == null ? undefined : json['features'],
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
    };
}

export function SubscriptionPackageToJSON(json: any): SubscriptionPackage {
    return SubscriptionPackageToJSONTyped(json, false);
}

export function SubscriptionPackageToJSONTyped(value?: SubscriptionPackage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'maxUsers': value['maxUsers'],
        'maxIntegrations': value['maxIntegrations'],
        'maxDomains': value['maxDomains'],
        'dataUpdatesPerDay': value['dataUpdatesPerDay'],
        'public': value['_public'],
        'isDefault': value['isDefault'],
        'monthlyCzk': value['monthlyCzk'],
        'yearlyCzk': value['yearlyCzk'],
        'monthlyEur': value['monthlyEur'],
        'yearlyEur': value['yearlyEur'],
        'allowDiscountCodeEvaluation': value['allowDiscountCodeEvaluation'],
        'allowInfluencerEvaluation': value['allowInfluencerEvaluation'],
        'allowAffiliateEvaluation': value['allowAffiliateEvaluation'],
        'isArchived': value['isArchived'],
        'retentionMonths': value['retentionMonths'],
        'isLegacy': value['isLegacy'],
        'features': value['features'],
        'id': value['id'],
    };
}

